import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { ModalWrapper, ModalDescription } from './styles';

const ModalCountdown = ({ modalCountdown, setModalCountdown }) => {
  const [counter, setCounter] = useState(20);

  useEffect(() => {
    if (modalCountdown && counter > 0) {
      const timer = setTimeout(() => {
        setCounter(counter - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else if (modalCountdown && counter === 0) {
      setCounter(20);  
    }
  }, [modalCountdown, counter]);

  useEffect(() => {
    if (modalCountdown) {
      setCounter(20);
    }
  }, [modalCountdown]);

  const handleClose = () => {
    setModalCountdown(false);
  };

  return (
    <Modal
      open={modalCountdown}
      onClose={handleClose}
      aria-labelledby="countdown-modal-title"
      aria-describedby="countdown-modal-description"
      disableBackdropClick 
    >
      <ModalWrapper>
        <ModalDescription id="countdown-modal-description">
          Aguardando... {counter} segundos
        </ModalDescription>
      </ModalWrapper>
    </Modal>
  );
}

export default ModalCountdown;